<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <ContentOrLoading :style="!listaAbonados ? 'padding: 100px;' : ''">
            <div class="row" v-if="listaAbonados">
                <div class="col-12">
                    <div class="form-group mb-4">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="check_sale" v-model="listaAbonados.check_sale"/>
                            <label class="custom-control-label text-uppercase h6" style="padding-top: 2px;" for="check_sale">Activar venta de abonados</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="imagen">Imagen:</label>
                        <p>
                            <small>
                                FORMATO: JPG
                            </small>
                        </p>
                        <template v-if="listaAbonados.imagen !== null">
                            <img :src="listaAbonados.imagen" style="max-height: 300px"/>
                            <br/>
                            <Button class="mt-1" @click="imagenBorrada()">Borrar</Button>
                        </template>
                        <template v-else>
                            <Dropzone 
                                v-if="url"
                                :url="url"
                                @success="imagenSubida"
                            />
                        </template>
                    </div>
                    <div class="form-group">
                        <label for="nombre">Abonos</label>
                        <ValidationProvider name="abonos" :rules="listaAbonados && listaAbonados.texto_abonos ? 'required' : ''" v-slot="{ errors }">
                            <CkEditorComponent v-model="listaAbonados.texto_abonos"/>
                            <span v-if="errors[0]" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label for="nombre">Precios</label>
                        <ValidationProvider name="precios" :rules="listaAbonados && listaAbonados.texto_precios ? 'required' : ''" v-slot="{ errors }">
                            <CkEditorComponent v-model="listaAbonados.texto_precios"/>
                            <span v-if="errors[0]" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="col-12 text-right mt-3">
                    <Button type="submit" name="button" :disabled="loading">CONTINUAR</Button>
                </div>
            </div>
        </ContentOrLoading>
    </ValidationObserver>
</template>
<script>
    import Dropzone from '@/components/common/Dropzone';
    import CkEditorComponent from "../../common/forms/CkEditorComponent.vue";
  
    export default {
        props: ['listaAbonados'],
        data() {
            return {
                loading: false,
                url: this.config.API_BASE + '/upload/image?api_key=' + localStorage.getItem('token') + '&permisos=public'
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crearAbonado();
                }        
            },
            crearAbonado() {
                this.$emit('terminado');
            },
            imagenBorrada() {
                this.listaAbonados.imagen = null
            },
            imagenSubida(file, response) {
                this.listaAbonados.imagen = 'https://storage.compralaentrada.com/' + response;
            }
        },
        components: {
            Dropzone, CkEditorComponent
        }
    }
</script>
  